








































































































































































































































































































































































































































































































































































































































































































































// @ is an alias to /src
import { Component, Emit, Vue } from "vue-property-decorator";
import Formulario from "@/components/Formulario.vue";
import Navbar from "@/components/Navbar.vue";
import Promotion from "@/components/Promotion.vue";

@Component({
  components: {
    Formulario,
    Navbar,
  },
})
export default class Ciaz extends Vue {
  @Emit()
  openModalDetalle(
    auto: string,
    titulo: string,
    interes: string,
    version: string
  ) {
    return {
      auto: auto,
      titulo: titulo,
      interes: interes,
      version: version,
    };
  }

  expand: boolean = true;
  toggleExpand() {
    this.expand = !this.expand;
  }

  checkbox: String = "Manual";
  checked: boolean = false;
  toggleCheckbox() {
    let inputCheck: any = document.getElementById("check");
    this.checked = !this.checked;
    inputCheck.checked = this.checked;
    this.checkbox = this.checkbox == "Manual" ? "Automático" : "Manual";
  }
}
